__turbopack_context__.v({
  "back-button": "-AdA3q_back-button",
  "double": "-AdA3q_double",
  "form": "-AdA3q_form",
  "island": "-AdA3q_island",
  "no-navbar": "-AdA3q_no-navbar",
  "shimmer": "-AdA3q_shimmer",
  "side-image": "-AdA3q_side-image",
  "single": "-AdA3q_single",
  "text-bar-sweep": "-AdA3q_text-bar-sweep",
  "video": "-AdA3q_video",
});
